import React from "react";
import { withStyles } from "@material-ui/styles";
import PropTypes from "prop-types";

import Dialog from "@material-ui/core/Dialog";

import ValueDetails from "./ValueDetails";
import Override from "./Override";

const styles = {
  dialogRoot: {
    //zIndex: "8000 !important",
  },
  dialog: {
    maxWidth: "1280px",
    maxHeight: "calc(100vh - 32px)",
    width: "850px",
    height: "900px",
    padding: "5px 15px",
    margin: "16px",
  },
};

const CorrectConfirmValue = (props) => {
  const { 
    classes, 
    section,
    open, 
    close,
    initialValue,
    setInitialValue,
    photos,
    profileType,
    profile,
    detectionEventGroup,
    refreshDetectionEventGroup,
    reloadEventGroupAndFocusElement,
    dacId,
    tabs,
    liveEventCardType, 
    liveZoneId 
  } = props;

  const [overrideData, setOverrideData] = React.useState();
  const [dirtyData, _setDirtyData] = React.useState(false);
  const dirtyDataRef = React.useRef(dirtyData);
  const setDirtyData = (data) => {
    dirtyDataRef.current = data;
    _setDirtyData(data);
  }

  const ccvRefresh = () => {
    setDirtyData(true);
  };

  // Close interceptor to handle dirty state
  const ccvClose = () => {
    if (dirtyDataRef.current) {
      refreshDetectionEventGroup();
    }
    setDirtyData(false);
    setOverrideData(null);
    close();
  };

  if (!profileType || !open) {
    return null;
  }
  
  return (
    <Dialog
      open={open}
      classes={{
        root: classes.dialogRoot,
        paperScrollPaper: classes.dialog,
      }}
    >
      {overrideData ? (
        <Override
          section={section}
          close={ccvClose}
          dacId={dacId}
          tabs={tabs}
          overrideData={overrideData}
          photos={photos}
          detectionEventGroup={detectionEventGroup}
          refresh={ccvRefresh}
          setOverrideData={setOverrideData}
          isLive={false}
          liveEventCardType={liveEventCardType}
          liveZoneId={liveZoneId}
        />
      ) : (
        <ValueDetails
          section={section}
          close={ccvClose}
          initialValue={initialValue}
          setInitialValue={setInitialValue}
          photos={photos}
          profileType={profileType}
          profile={profile}
          detectionEventGroup={detectionEventGroup}
          reloadEventGroupAndFocusElement={reloadEventGroupAndFocusElement}
          setOverrideData={setOverrideData}
        />
      )}
    </Dialog>
  );
};

CorrectConfirmValue.propTypes = {
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  initialValue: PropTypes.object,
  setInitialValue: PropTypes.func,
  photos: PropTypes.array.isRequired,
  profileType: PropTypes.oneOf([2, 3, 8]).isRequired,
  profile: PropTypes.object,
  detectionEventGroup: PropTypes.object,
  refreshDetectionEventGroup: PropTypes.func.isRequired,
  reloadEventGroupAndFocusElement: PropTypes.func.isRequired,
  dacId: PropTypes.number.isRequired,
  tabs: PropTypes.object,
  liveEventCardType:PropTypes.string,
  liveZoneId: PropTypes.number
};

export default withStyles(styles)(CorrectConfirmValue);
